/* global common */
import { sendAmplitudeEvent, getBreakpointMinWidth } from '@html/_common/utils';

export default function AOPaxMonth(stickyMenu) {
  this.common = {};
  if (typeof sendAmplitudeEvent !== 'undefined') {
    this.common = { sendAmplitudeEvent, getBreakpointMinWidth };
  } else {
    this.common = common;
  }
  this.stickyMenu = stickyMenu;

  const SELECTOR_PAX_MONTH = '.js-ao-pax-month';
  const PAX_MONTH_DISABLED_CLASS = 'ao-pax-selector--disabled';
  const SELECTOR_PAX_MONTH_DROPDOWN = '.js-ao-pax-month__dropdown-toggle';
  const MOBILE_WIDTH = this.common.getBreakpointMinWidth('m2') - 1;
  const SELECTOR_PAX_MONTH_TEXT = '.js-ao-pax-selector-month';

  const isInMobileWidth = (width) => width <= MOBILE_WIDTH;

  const getDeviceType = (width) => {
    if (isInMobileWidth(width)) {
      return 'mobile';
    }
    return 'desktop';
  };

  const isMobileDevice = () => getDeviceType($(window).width()) === 'mobile';
  const isDesktopDevice = () => getDeviceType($(window).width()) === 'desktop';

  const closeOpenMenu = () => {
    $(SELECTOR_PAX_MONTH).each(function () {
      const $component = $(this);
      const $menu = $component.find('.js-ao-pax-month__dropdown-toggle');

      // Run the close-up code only when the menu is open
      if (!$menu.hasClass('hid')) {
        $menu.addClass('hid'); // hide the dropdown
        $component.find('.ao-pax-selector__arrow') // reset the arrow
          .removeClass('ao-pax-selector__arrow--rotated');
      }
    });
  };

  const handleOutsideClick = (e) => {
    // Bail out if the click was inside the component
    if ($(e.target).closest(SELECTOR_PAX_MONTH).length) return;

    // Otherwise, close only the components whose menus are actually open
    closeOpenMenu();
  };

  this.enableMenu = () => {
    $(SELECTOR_PAX_MONTH).removeClass(PAX_MONTH_DISABLED_CLASS);
  };

  const showMenu = (e) => {
    const $currentTarget = $(e?.currentTarget);
    if ($currentTarget.hasClass(PAX_MONTH_DISABLED_CLASS)) return;
    const $dropdown = $currentTarget.find(SELECTOR_PAX_MONTH_DROPDOWN);

    // Close any other dropdowns with the same class that are not children of the current target
    $(SELECTOR_PAX_MONTH_DROPDOWN).not($dropdown).addClass('hid');
    $(SELECTOR_PAX_MONTH).find('.ao-pax-selector__arrow').not($currentTarget.find('.ao-pax-selector__arrow')).removeClass('ao-pax-selector__arrow--rotated');

    if (!$(e.target).closest($dropdown).length) {
      $dropdown.toggleClass('hid');
      $currentTarget.find('.ao-pax-selector__arrow').toggleClass('ao-pax-selector__arrow--rotated');
    }
  };

  const listenToMonthChanges = () => {
    $(document).on('paxSelection:monthChange', (_, monthData) => {
      // Batch all DOM updates in the next frame to improve INP
      requestAnimationFrame(() => {
        // Cache selectors to avoid repeated DOM queries
        const $paxMonthText = $(SELECTOR_PAX_MONTH_TEXT);
        const $paxMonth = $(SELECTOR_PAX_MONTH);

        // Update text and attributes together
        $paxMonthText.text(`${monthData.monthName} ${monthData.year}`);
        $paxMonth.attr('data-pax-month', monthData.month);
        $paxMonth.attr('data-pax-year', monthData.year);

        // Close menus in the same frame to batch layout recalculations
        if (isDesktopDevice()) {
          closeOpenMenu();
        }
        if (isMobileDevice()) {
          // Only close sticky menu if there's only 1 component in the currently opened sheet
          const $openedSheet = $('.js-ao-sticky-menu__sheet:not(.hid)');
          const $stickyComponents = $openedSheet.find('.js-ao-sticky-menu__component');
          if ($stickyComponents.length === 0) {
            this.stickyMenu?.closeStickyMenu();
          }
        }
      });
    });
  };

  this.initiate = () => {
    listenToMonthChanges();
    if (isDesktopDevice()) {
      $(document).on('click', SELECTOR_PAX_MONTH, showMenu);
      $(document).on('click', handleOutsideClick);
    }
    if (isMobileDevice()) {
      $(document).on('click', SELECTOR_PAX_MONTH, (event) => {
        const dataPlacement = $(event.currentTarget).attr('data-placement');
        const dataEventName = $(event.currentTarget).attr('data-event-name');
        if (this.stickyMenu) {
          this.stickyMenu.openStickyMenu();
        }
        $('.js-ao-pax-month-sheet').attr('data-placement', dataPlacement);
        $('.js-ao-pax-month-sheet').attr('data-event-name', dataEventName);
      });
    }
  };
}
